import { createApp } from 'vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
  faTrash,
  faPencil,
  faSquareCheck,
  faTimesSquare,
  faPlusSquare,
  faCodeBranch,
  faArrowUp,
  faArrowRight,
  faAngleDown,
  faAngleRight,
  faArrowDown,
} from '@fortawesome/free-solid-svg-icons';
import '@fortawesome/fontawesome-free/css/fontawesome.min.css';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';

library.add(
  faPlusSquare,
  faTrash,
  faPencil,
  faSquareCheck,
  faTimesSquare,
  faCodeBranch,
  faArrowUp,
  faArrowRight,
  faAngleDown,
  faAngleRight,
  faArrowUp,
  faArrowDown,
);

createApp(App)
  .component('fa-icon', FontAwesomeIcon)
  .use(store)
  .use(router)
  .mount('#app');
